export default {"src":"/_next/static/media/logo.ad35ca6b.svg","height":102,"width":359,"blurWidth":0,"blurHeight":0};